// mpp_custom_filters_v1.js
//
// This file replicates some of the php functionality in mac_product.module, specifically from
// mac_product_template_api_variables_alter() method, in the section that handles mpp_filters
var site = site || {};

(function ($) {
  Drupal.behaviors.mppCustomFilters_v1 = {
    attach: function (context) {
      $(window).on('productApp:products_added', function () {
        var $panel = $('.mpp-filters__placeholder');

        if ($panel.length < 1) {
          return null;
        }
        var filters = $panel.data('config');
        var prodObjs = site.productApp.products;
        var prodData = _.map(prodObjs, 'data');
        var mashedFacets;
        var facetsArray = [];
        var facetsObjCounts;
        var facets = [];
        var formatFacetKey = function (f) {
          f = f.toLowerCase();

          return f;
        };

        _.each(filters, function (filter) {
          facets = _.map(prodData, filter.filter_key);
          facets = _.filter(facets, function (f) {
            return !!f; // filter out non-truthy values, including 0 or empty string
          });
          _.each(facets, function (f, i) {
            if (_.isString(f)) {
              facets[i] = formatFacetKey(f); // convert to lower case
            }
          });

          facets = _.uniq(facets);
          facets.sort();
          mashedFacets = facets.join(',');
          facetsArray = mashedFacets.split(',').map(function (mashedFacet) {
            return mashedFacet.trim();
          });

          // Count frequencies of the facets
          facetsObjCounts = {};
          facetsArray.forEach(function (facet) {
            if (facet in facetsObjCounts) {
              facetsObjCounts[facet]++;
            } else {
              facetsObjCounts[facet] = 1;
            }
          });

          filter.filter_facets = [];
          _.each(facetsObjCounts, function (i, f) {
            filter.filter_facets.push({
              'facet_key': f,
              'facet_label': f,
              'facet_count': i
            });
          });
        });

        console.log(filters);

        // filters = [
        //   {
        //     'filter_label' : 'Finish',
        //     'filter_key' : 'ATTRIBUTE_DESC_1',
        //     'filter_facets': [
        //       {
        //         'facet_key' : 'matte',
        //         'facet_label' : 'Matte',
        //         'facet_count' : 12
        //       },
        //       {
        //         'facet_key' : 'cream',
        //         'facet_label' : 'Cream',
        //         'facet_count' : 3
        //       }
        //     ]
        //   },
        //   {
        //     'filter_label' : 'Coverage',
        //     'filter_key' : 'ATTRIBUTE_DESC_2',
        //     'filter_facets': [
        //       {
        //         'facet_key' : 'full',
        //         'facet_label' : 'Full',
        //         'facet_count' : 4
        //       }
        //     ]
        //   }
        // ];

        var filterData = {
          'mobile_button_label_static': $panel.data('mobile-button-label-static'),
          'filter_dropdown_collapsed_mobile': $panel.data('filter-dropdown-collapsed-mobile'),
          'mac_mpp_filters': filters
        };
        var html = site.template.get({
          data: filterData,
          name: 'mpp_filter_controls_v1'
        });

        $panel.html(html);
        site.mppFilterControls.init($panel);
      });
      if (site.productApp.products.length !== 0) {
        $(window).trigger('productApp:products_added');
      }
    }
  };
})(jQuery);
